/**
 * Common styles for the input fields in the Cielo TDC form.
 */
const inputStyles =
  'form-input rounded border-none shadow-[0px_0px_9px_.5px_#E6E6E6] focus:border focus:border-solid focus:border-accent-regular focus:outline-none focus:shadow-[0px_0px_4px_2px] focus:shadow-accent-regular/20';

export default inputStyles;
